import { render, staticRenderFns } from "./laser-details-content.vue?vue&type=template&id=377e35ff&"
import script from "./laser-details-content.vue?vue&type=script&lang=js&"
export * from "./laser-details-content.vue?vue&type=script&lang=js&"
import style0 from "./laser-details-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports